
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fleettrackingquotes/privacy-policy",
      function () {
        return require("private-next-pages/fleettrackingquotes/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fleettrackingquotes/privacy-policy"])
      });
    }
  